import { createSliceLayout } from "../../utils/create-slice-layout";
import { PageKnowledgeHubLayout } from "../entities/page-knowledge-hub-layout";
import { SliceBackgroundImage } from "../entities/slice-background-image";
import { SliceBlockBubbleLinks } from "../entities/slice-block-bubble-links";
import { SliceBlockBubbles } from "../entities/slice-block-bubbles";
import { SliceBlockGrid } from "../entities/slice-block-grid";
import { SliceBlockThumbnailGrid } from "../entities/slice-block-thumbnail-grid";
import { SliceBlurbImage } from "../entities/slice-blurb-image";
import { SliceBlurbVideo } from "../entities/slice-blurb-video";
import { SliceColorStrip } from "../entities/slice-color-strip";
import { SliceContactForm } from "../entities/slice-contact-form";
import { SliceContent } from "../entities/slice-content";
import { SliceContentBlockLinks } from "../entities/slice-content-block-links";
import { SliceContentEntityQuote } from "../entities/slice-content-entity-quote";
import { SliceContentImage } from "../entities/slice-content-image";
import { SliceDivider } from "../entities/slice-divider";
import { SliceFeaturedOrganisation } from "../entities/slice-featured-organisation";
import { SliceFeaturedPosts } from "../entities/slice-featured-posts";
import { SliceFeatureTout } from "../entities/slice-feature-tout";
import { SliceHairline } from "../entities/slice-hairline";
import { SliceHeader } from "../entities/slice-header";
import { SliceHeaderDivider } from "../entities/slice-header-divider";
import { SliceImage } from "../entities/slice-image";
import { SliceIntro } from "../entities/slice-intro";
import { SliceJumpLinks } from "../entities/slice-jump-links";
import { SliceKeyMessage } from "../entities/slice-key-message";
import { SliceLatestInsights } from "../entities/slice-latest-insights";
import { SliceOrganisationBioGrid } from "../entities/slice-organisation-bio-grid";
import { SliceOrganisations } from "../entities/slice-organisations";
import { SlicePastEvents } from "../entities/slice-past-events";
import { SlicePersonBioGrid } from "../entities/slice-person-bio-grid";
import { SliceQuestion } from "../entities/slice-question";
import { SliceSectionColorBlock } from "../entities/slice-section-color-block";
import { SliceSpacer } from "../entities/slice-spacer";
import { SliceThumbnailStrip } from "../entities/slice-thumbnail-strip";
import { SliceUpcomingEvents } from "../entities/slice-upcoming-events";
import { SliceValueTout } from "../entities/slice-value-tout";
/*

This file exports the DEFAULT slice layouts for the site, which allows Shapeable sites
to use a standard set of components based on our design library.

These can be overridden by passing a custom set of layouts to the SliceLayoutsProvider in the website.

*/

export var SliceLayoutBlurbImage = createSliceLayout(SliceBlurbImage, {
  verticalPadding: 'small'
});
export var SliceLayoutBlurbVideo = createSliceLayout(SliceBlurbVideo, {
  verticalPadding: 'small'
});
export var SliceLayoutBackgroundImage = createSliceLayout(SliceBackgroundImage);
export var SliceLayoutBlockBubbleLinks = createSliceLayout(SliceBlockBubbleLinks);
export var SliceLayoutBlockBubbles = createSliceLayout(SliceBlockBubbles);
export var SliceLayoutBlockGrid = createSliceLayout(SliceBlockGrid, {
  verticalPadding: 'content'
});
export var SliceLayoutBlockThumbnailGrid = createSliceLayout(SliceBlockThumbnailGrid, {
  verticalPadding: 'none',
  boundary: 'none'
});
export var SliceLayoutColorStrip = createSliceLayout(SliceColorStrip, {
  props: {
    colors: ['primary', 'secondary']
  }
});
export var SliceLayoutContactForm = createSliceLayout(SliceContactForm, {
  props: {
    variant: 'inline',
    showMembershipCheckbox: false
  }
});
export var SliceLayoutContentBlockLinks = createSliceLayout(SliceContentBlockLinks, {
  verticalPadding: 'medium'
});
export var SliceLayoutContent = createSliceLayout(SliceContent, {
  verticalPadding: 'small'
});
export var SliceLayoutContentEntityQuote = createSliceLayout(SliceContentEntityQuote, {
  boundary: 'none',
  props: {
    parallax: true
  }
});
export var SliceLayoutContentImage = createSliceLayout(SliceContentImage, {
  verticalPadding: 'small'
});
export var SliceLayoutContentImageReverse = createSliceLayout(SliceContentImage, {
  verticalPadding: 'small',
  props: {
    reverse: true
  }
});
export var SliceLayoutDivider = createSliceLayout(SliceDivider, {
  boundary: 'content-bleed'
});
export var SliceLayoutHairline = createSliceLayout(SliceHairline, {
  boundary: 'content-bleed'
});
export var SliceLayoutFeaturedPosts = createSliceLayout(SliceFeaturedPosts, {
  boundary: 'content',
  props: {}
});
export var SliceLayoutFeatureTout = createSliceLayout(SliceFeatureTout);
export var SliceLayoutFeaturedOrganisation = createSliceLayout(SliceFeaturedOrganisation, {
  verticalPadding: 'large'
});
export var SliceLayoutHeader = createSliceLayout(SliceHeader, {
  verticalPadding: 'small'
});
export var SliceLayoutHeaderDivider = createSliceLayout(SliceHeaderDivider, {
  verticalPadding: 'content'
});
export var SliceLayoutImage = createSliceLayout(SliceImage, {
  boundary: 'content',
  useBackgroundImages: false // turn off background images, as we want to push this one to the foreground to allow optimisation

});
export var SliceLayoutImageFill = createSliceLayout(SliceImage, {
  boundary: 'none',
  useBackgroundImages: false // turn off background images, as we want to push this one to the foreground to allow optimisation

});
export var SliceLayoutIntro = createSliceLayout(SliceIntro, {
  verticalPadding: 'large'
});
export var SliceLayoutJumpLinks = createSliceLayout(SliceJumpLinks, {
  boundary: 'content'
});
export var SliceLayoutKeyMessage = createSliceLayout(SliceKeyMessage, {
  verticalPadding: 'large'
});
export var SliceLayoutKnowledgeHub = createSliceLayout(PageKnowledgeHubLayout, {
  boundary: 'content-bleed',
  verticalPadding: 'medium',
  props: {
    showAllTab: true,
    entityTypes: {
      Post: {
        label: 'Posts',
        sortBy: 'published',
        reverse: true
      },
      FeedEntry: {
        label: 'Innovations',
        sortBy: 'published',
        reverse: true
      },
      Citation: {
        label: 'Research',
        spacing: 4
      },
      Video: {
        label: 'Video'
      }
    }
  }
});
export var SliceLayoutLatestInsights = createSliceLayout(SliceLatestInsights, {
  boundary: 'content-bleed',
  verticalPadding: 'small'
});
export var SliceLayoutOrganisationBioGrid = createSliceLayout(SliceOrganisationBioGrid, {
  verticalPadding: 'content'
});
export var SliceLayoutOrganisations = createSliceLayout(SliceOrganisations, {
  verticalPadding: 'content'
});
export var SliceLayoutPastEvents = createSliceLayout(SlicePastEvents, {
  verticalPadding: 'content'
});
export var SliceLayoutPeople = createSliceLayout(SlicePersonBioGrid, {
  verticalPadding: 'small',
  props: {
    transform: 'grayscale'
  }
});
export var SliceLayoutQuestion = createSliceLayout(SliceQuestion, {
  boundary: 'content'
});
export var SliceLayoutSection = createSliceLayout(SliceSectionColorBlock, {
  boundary: 'none',
  props: {
    aspectRatio: {
      base: 16 / 9,
      landscape: 21 / 9,
      tablet: 21 / 9,
      desktop: 2.5
    }
  }
});
export var SliceLayoutSectionReverse = createSliceLayout(SliceSectionColorBlock, {
  boundary: 'none',
  props: {
    aspectRatio: {
      base: 16 / 9,
      landscape: 21 / 9,
      tablet: 21 / 9,
      desktop: 2.5
    },
    isReversed: true
  }
});
export var SliceLayoutSpacer32 = createSliceLayout(SliceSpacer, {
  props: {
    units: 32 / 4
  }
});
export var SliceLayoutSpacer64 = createSliceLayout(SliceSpacer, {
  props: {
    units: 64 / 4
  }
});
export var SliceLayoutSpacer96 = createSliceLayout(SliceSpacer, {
  props: {
    units: 96 / 4
  }
});
export var SliceLayoutSpacer128 = createSliceLayout(SliceSpacer, {
  props: {
    units: 128 / 4
  }
});
export var SliceLayoutSpacer192 = createSliceLayout(SliceSpacer, {
  props: {
    units: 192 / 4
  }
});
export var SliceLayoutSpacer256 = createSliceLayout(SliceSpacer, {
  props: {
    units: 256 / 4
  }
});
export var SliceLayoutThumbnailStrip = createSliceLayout(SliceThumbnailStrip, {
  boundary: 'none'
});
export var SliceLayoutUpcomingEvents = createSliceLayout(SliceUpcomingEvents, {
  verticalPadding: 'content'
});
export var SliceLayoutValueTout = createSliceLayout(SliceValueTout, {
  boundary: 'content-bleed'
});
export var SliceLayoutDefault = SliceLayoutContent;